import React, { useEffect } from "react";
import { Auth, API } from "aws-amplify";
import { useNavigate, useLocation } from "react-router-dom";
import { createUser } from '../graphql/mutations';
import { getUser } from '../graphql/queries';

const PostLogin = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const error = params.get("error");
    const errorDescription = params.get("error_description");

    // Check if user canceled or access was denied
    if (
      error === "access_denied" ||
      (errorDescription && errorDescription.toLowerCase().includes("access_denied"))
    ) {
      console.warn("Amazon Login canceled or access denied:", errorDescription);
      navigate("/signin");
      return;
    }

    const checkOrCreateUser = async () => {
      try {
        const cognitoUser = await Auth.currentAuthenticatedUser();
        console.log("cognitoUser:", cognitoUser);

        const attributes = cognitoUser.attributes || {};
        const payload = cognitoUser.signInUserSession?.idToken?.payload || {};

        const email = attributes.email || payload.email;
        const firstName =
          attributes.given_name || payload.given_name || attributes.name?.split(" ")[0] || "";
        const lastName =
          attributes.family_name || payload.family_name || attributes.name?.split(" ")[1] || "";

        const credentials = await Auth.currentUserCredentials();

        const userResult = await API.graphql({
          query: getUser,
          variables: { id: email }
        });
        if (!userResult.data.getUser) {
          const createUserPayload = {
            id: email,
            email,
            username: email,
            identityID: credentials.identityId,
            firstName,
            lastName,
            hasRfToken: false,
          };

          await API.graphql({
            query: createUser,
            variables: { input: createUserPayload },
          });
        }

        await Auth.currentSession();
        navigate("/products");
      } catch (err) {
        navigate("/login");
      }
    };

    checkOrCreateUser();
  }, [navigate, location]);

  return (
    <div style={{ textAlign: "center", padding: "4rem" }}>
      <h2>Signing in from Amazon...</h2>
      <p>Just a moment, getting things ready!</p>
    </div>
  );
};

export default PostLogin;
